import { render, staticRenderFns } from "./work_order_detail.vue?vue&type=template&id=93c481ae&scoped=true&"
import script from "./work_order_detail.vue?vue&type=script&lang=js&"
export * from "./work_order_detail.vue?vue&type=script&lang=js&"
import style0 from "./work_order_detail.vue?vue&type=style&index=0&id=93c481ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c481ae",
  null
  
)

export default component.exports